var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showSidebar)?_c('div',{staticClass:"hidden lg:flex lg:flex-shrink-0"},[_c('div',{staticClass:"flex flex-col w-96"},[_c('default-sidebar')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }